import { motion } from "framer-motion";

export function StatusBadge({ map, value, fallback }) {
  const item = map?.[value];
  const label = typeof item === "string" ? item : item?.label || fallback || value || "—";
  const cls = typeof item === "object" ? item?.cls : "bg-zinc-500/15 text-zinc-400 border-zinc-500/30";
  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium ${cls}`}>
      {label}
    </span>
  );
}

export function PageHeader({ title, subtitle, children, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8" data-testid={testid}>
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-medium tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1 text-sm">{subtitle}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}

export function Page({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
      className="p-6 sm:p-8 lg:p-10 max-w-[1600px] mx-auto relative z-10"
    >
      {children}
    </motion.div>
  );
}

export function Empty({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      {Icon && <Icon className="w-10 h-10 text-muted-foreground mb-4" strokeWidth={1.5} />}
      <p className="font-display text-lg">{title}</p>
      {hint && <p className="text-muted-foreground text-sm mt-1 max-w-sm">{hint}</p>}
    </div>
  );
}
